<script setup lang="ts">
import type { LessonRecurringAvailabilityLabel } from '../../model/lessons/lesson-recurring'

import { AppDropdownItem } from '@shared/ui/dropdowns'
import { AppBadge } from '@shared/ui/badges'

defineOptions({
  name: 'LessonRecurringTutorOption',
})

/** A row of the recurring tutor list: the tutor's name with their colored availability tag. */
withDefaults(defineProps<{
  text: string
  selected?: boolean
  label?: LessonRecurringAvailabilityLabel | null
}>(), {
  selected: false,
  label: null,
})
</script>

<template>
  <AppDropdownItem
    tag="div"
    :text="text"
    :selected="selected"
    tabindex="-1"
  >
    <template
      v-if="label"
      #status-tag
    >
      <AppBadge
        :color="label.color"
        :text="label.text"
      />
    </template>
  </AppDropdownItem>
</template>
